import { useRef, useEffect } from 'react';
import moment from "moment";
import useAuth from './useAuth';
import axios from '../api/axios';
const LOGIN_URL = '/auth/login';
//const wait = t => new Promise((resolve, reject) => setTimeout(resolve, t))
const Login = () => {
    const { setAuth } = useAuth();
    const callCount = useRef(10);

    useEffect(() => {
        const controller = new AbortController();

        const loginAPI = async () => {
            try {
                // for DEBUG/Log
                //const zac = moment();
                //console.log(callCount.current.toString() + ". call login " + zac.toLocaleString())
                //console.log(LOGIN_URL + '?username=' + user + '&password=' + pwd)
                const response = await axios.post(LOGIN_URL, {
                    username: process.env.REACT_APP_API_LOGIN,
                    password: process.env.REACT_APP_API_PWD
                },
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );
                //const kon = moment();
                //const duration = moment.duration(kon.diff(zac)).asMilliseconds();
                //console.log(callCount.current.toString() + ". LOGIN RESPONSE" + kon.toLocaleString() + "\n" + duration.toString())
                const accessToken = response?.data?.token;
                const refreshToken = response?.data?.refreshToken;
                setAuth({ accessToken, refreshToken });
                callCount.current = 0;
            } catch (err) {
                const kon = moment();
                if (process.env.NODE_ENV === 'development') {
                    console.log(callCount.current.toString() + ". Error RESPONSE - " + kon.toLocaleString())
                    console.log(callCount.current.toString() + ". - " + err)
                }
                callCount.current -= 1;
                if (callCount.current > 0) loginAPI();
                else console.log("Couldn't authenticate");
            }
        }

        loginAPI();

        return () => {
            controller.abort();
        }
    }, [callCount, setAuth]);

}

export default Login